import React from "react";
import { useLang } from "../context/LanguageContext";
import { Heart, Sun, Sprout } from "lucide-react";

const pillarIcons = [Heart, Sun, Sprout];
const pillarColors = ["#E63946", "#FFD500", "#2E9E4E"];

const About = () => {
  const { t } = useLang();
  return (
    <section id="nosotros" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <div className="text-xs md:text-sm font-bold uppercase tracking-[0.25em] text-[#E63946] mb-4">
              {t.about.overline}
            </div>
            <h2 className="font-fredoka text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05] text-[#1D3557]">
              {t.about.title}
            </h2>
          </div>
          <div className="lg:col-span-7">
            <p className="text-lg md:text-xl leading-relaxed text-[#457B9D]">
              {t.about.body}
            </p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {t.about.pillars.map((p, i) => {
            const Icon = pillarIcons[i];
            return (
              <div
                key={i}
                data-testid={`about-pillar-${i}`}
                className="relative group bg-white rounded-[2rem] p-8 md:p-10 border border-[#E2E8F0]/70 shadow-[0_20px_40px_rgba(29,53,87,0.06)] hover:shadow-[0_30px_60px_rgba(29,53,87,0.12)] hover:-translate-y-1 transition-all"
              >
                <div
                  className="w-14 h-14 rounded-2xl grid place-items-center mb-6"
                  style={{ backgroundColor: `${pillarColors[i]}22` }}
                >
                  <Icon className="w-7 h-7" strokeWidth={2.5} style={{ color: pillarColors[i] }} />
                </div>
                <h3 className="font-fredoka text-2xl font-semibold text-[#1D3557] mb-3">{p.title}</h3>
                <p className="text-[#457B9D] leading-relaxed">{p.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
